import React, { useEffect, useRef, useState, useCallback, Fragment } from 'react';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { usePagination } from 'Components/uiControls/Table/hooks';
import { Container } from '@mui/material';
import moment from 'moment';
import { TableView as Table, SearchInput, MenuComponent, IconButton, Tooltip } from '@gpstrackit/gtc-react-controls';

import { NotificationManager } from 'Components/Notifications';
import { IconMarkerRoutesTrackerSmall } from '../../../../components/Map/iconsReact'

import { ColorsToRoutePointsOnRoutesTracker, ColorsToRouteStatus } from '../../../../components/Map/providers/enums'
import { GetFormatForMoment } from 'Core/data/Helpers';

import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import {Timezone} from '../../../../components/uiControls';
import { Avatar } from 'Components';

//controls
import ModalRouteFilters from './components/modalFilters'
import ModalRouteStopInformation from './components/modalStopInformation'
import ModalRouteStopVisited from './components/modalStopsVisited'
import ModalAddRoutesTracker from './components/modalAddRoutesTracker'

import { Pill as NewPill } from '@gpstrackit/gtc-react-controls';

import Pill from "Components/Pill";

import './style.scss';

import {
    Grid,
    Grow,
    Typography
  } from '@mui/material';

import {
    openModalRoutesTrackerFilter,
    openModalRoutesTrackerStopInformation,
    openModalRoutesTrackerStopsVisited,
    openModalRoutesTrackerAddRoutesTracker,
    openModalCreateEditRouteModalMain,
    setRoutesTrackerFilters,
    routesSearchRoutes,
    openModalDeleteRoutes,
    searchRoutesTrackerRefresh,
    openOverViewUnit
  } from 'Redux/actions';


import { HasPermission } from "Core/security"

import { routesTrackerSearchRoutes } from './redux/slice'

import { reset as resetRouteManagerCreateEditModalMain } from '../templates/components/createEditRouteModalMain/redux/slice';

import {
  reset as resetModalCreateEditRoute
} from "../../../../modules/realtimeMaps/main/components/routes/components/modalCreateEditRoute/redux/slice"
import { reset as clearCreateEditRoutePoint } from '../templates/components/createEditRoutePoint/redux/slice'
import { reset as resetEditPanelRoute } from '../templates/components/editPanelRoute/redux/slice'
import { reset as resetDeleteRoutePoint } from '../templates/components/deleteRoutePoint/redux/slice'
import { reset as resetDeleteRoute } from '../templates/components/deleteRoute/redux/slice'//'../deleteRoute/redux/slice'

const RoutesTracker = () => {

    //intl
    const { messages, locale } = useIntl();
    const dispatch = useDispatch();

    const user = useSelector((state) => state.securityRedux.user);

    const [data, setData] = useState([]);

    const dataRoutesItems = useSelector(state => state.routesTrackerRedux.routes);

    const openModalFilter = useSelector(state => state.routesTrackerModalFilterRedux?.open);
    const openModalRouteStopInformation = useSelector(state => state.routesTrackerModalStopInformationRedux?.open);
    const openModalRouteStopsVisited = useSelector(state => state.routesTrackerModalStopsVisitedRedux?.open);
    
    const loadingRoutes = useSelector(state => state.routesTrackerRedux.loadingRoutes);
    const filters = useSelector(state => state.routesTrackerRedux.filters);
    const openModalCreateEditRoute = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.open);

    const loadingSavedRoute = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.loadingSavedRoute);
    const cloneRouteResponse = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.cloneRouteResponse);
    const erorrRoutes = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux.erorrRoutes);
    const isDeleteRoutes = useSelector(state => state.routesManagerDeleteRedux.isDeleteRoutes);
    const openModalDeleteRoute = useSelector(state => state.routesManagerDeleteRedux?.openModal);
    const driversSelect = useSelector(state => state.routesTrackerModalFilterRedux.filters.drivers);
    const dateStart = useSelector(state => state.routesTrackerModalFilterRedux.filters.dateStart);
    const dateEnd = useSelector(state => state.routesTrackerModalFilterRedux.filters.dateEnd);
    const filtersModal = useSelector(state => state.routesTrackerModalFilterRedux.filters);
    const timeZoneUser = useSelector((state) => state.securityRedux.user.timeZone);
    const isCloneRoute = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.isCloneRoute);
    const isRoutesTracker = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.isRoutesTracker);
    const openAddRoutesTracker = useSelector(state => state.routesTrackerModalAddRoutesTrackerRedux?.open);
    const createUpdateRoutePointResponse = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux.createUpdateRoutePointResponse)
    const searchRoutesTracker = useSelector(state => state.routesTrackerRedux.searchRoutesTracker)
    const timeFrameOptionSelected = useSelector(state => state.routesTrackerModalFilterRedux?.filters?.timeFrameOptionSelected)
    const dateformat = useSelector(state => state.securityRedux.user.dateformat);

    const [rowsPerPage, setRowsPerPage] = useState(10);

    const routesTableRef = useRef();

    const searchRoutesToFilter = () => {

      const conditions = []

      let fields = []
      let terms = []

      //is Assigned Route
      if(driversSelect?.length > 0){

          fields = []
          terms = []
          fields.push("driverId")
          driversSelect.forEach((item) => {
              terms.push(item.driverId)
          })

          conditions.push({
              fields: fields,
              terms: terms,
              exact: 1
          })
      }

      conditions.push({
          range: {
              fields: ['scheduledAt'],
              GTE: dateStart || moment().startOf('day'),
              LTE: dateEnd || moment.max(moment()).endOf('day'),
          }
      })       
      return conditions;

  }

    const pagination = usePagination(routesTableRef, routesTrackerSearchRoutes, {...filters, paramConditions: searchRoutesToFilter()});

    useEffect(() => {
        if (dataRoutesItems) {
          setData(dataRoutesItems);
          pagination.setTotal(dataRoutesItems?.total || 0);
        }
      }, [dataRoutesItems]);

    useEffect(()=>{
      if(isDeleteRoutes){
        pagination?.resetTable()
        setRowsPerPage(10)
        //routesTableRef?.current?.setRowsPerPage(10)
        pagination.setSelectedItems([])
      }
    },[isDeleteRoutes])

    useEffect(()=> {
      if(searchRoutesTracker){
        dispatch(routesTrackerSearchRoutes({...filters, paramConditions: searchRoutesToFilter()}))
        dispatch(searchRoutesTrackerRefresh(false))
      }
    },[searchRoutesTracker])

    useEffect(()=> {
      if(loadingSavedRoute || cloneRouteResponse || erorrRoutes){
        if(erorrRoutes){
          NotificationManager.error(
            messages[erorrRoutes]? messages[erorrRoutes] : erorrRoutes,
            messages["error"],
            3000,
            null,
            null,
            "warning"
          )
        }else{
          NotificationManager.success(
            loadingSavedRoute ? messages['fsmRoute_label_add_route_save'] : messages['fsmRoute_label_add_clone_route_success'],
            messages["success"],
            3000,
            null,
            null,
            "success"
          )
          //dispatch(resetRouteManagerCreateEditModalMain({ isCloneRoute: false, isRoutesTracker: false }))
        }
        if(!erorrRoutes && !isRoutesTracker){

          //---------------------------------------
          //Reset the modal to create routes
          dispatch(clearCreateEditRoutePoint())
          dispatch(resetRouteManagerCreateEditModalMain())
          dispatch(resetModalCreateEditRoute())
          dispatch(resetEditPanelRoute())
          dispatch(resetDeleteRoutePoint())
          dispatch(resetDeleteRoute({ openModal: false }))
          //---------------------------------------
        }

        if(!erorrRoutes){
          if(isCloneRoute || isRoutesTracker){
            //is new routes tracker
            dispatch(routesTrackerSearchRoutes({...filters, paramConditions: searchRoutesToFilter()}))
          }else{
            //is new template
            dispatch(routesSearchRoutes({...filters}))
          }          
        }           

        /* dispatch(resetRouteManagerCreateEditModalMain({ 
          loadingSavedRoute: false, 
          cloneRouteResponse: false, 
          erorrRoutes: null, 
          templateRouteId: 0, 
          driverId: 0,
          scheduledAt: null  
        })) */

      }
    },[loadingSavedRoute, cloneRouteResponse, erorrRoutes])

    useEffect(() => {
      if (createUpdateRoutePointResponse) {
        if (erorrRoutes) {
          NotificationManager.error(
            messages['routes_error'],
            messages['error'],
            3000,
            null,
            null,
            'warning',
          );
        } else {
          NotificationManager.success(
            messages['routes_create_edit_point_new'],
            messages["success"],
            3000,
            null,
            null,
            "success"
          )  
        }
      }
    }, [createUpdateRoutePointResponse]);


    const getDate = (dateIn, timezone) => {
      let date = moment(dateIn)
      if (!date.isValid()) {
          if (dateIn && dateIn.length > 10) {
              date = moment.unix(Number(dateIn?.substring(0, dateIn.length - 3)))
          } else {
              date = moment.unix(Number(dateIn))
          }
      }
  
      if(timezone){
          date = date.tz(timezone);
      }
  
      return date;
    }

    

    const onChangePage = useCallback((newPage, newRowsPerPage, newSearchText) => {
      const newOffset = (newPage - 1) * newRowsPerPage;
      dispatch(routesTrackerSearchRoutes({
          ...filters,
          openSearch: newSearchText || "",
          limit: newRowsPerPage,
          offset: newOffset,
          paramConditions: searchRoutesToFilter()
      }));
    });

    const onSearchText = (newSearchText) => {
      pagination.setSearchText(newSearchText);

        if (window.typingTime) {
            clearTimeout(window.typingTime);
        }

        window.typingTime = setTimeout(() => {
            dispatch(setRoutesTrackerFilters({ ...filtersModal, routeName: newSearchText }))
            pagination.setSelectedItems([]);
            onChangePage(1, rowsPerPage, newSearchText);
            window.typingTime = null;
        }, 500);
    }

    useEffect(() => {
        pagination.setColumns([
          {
            key: 'title',
            title: messages['fsmRoute_routesTracker_name'], //name
            show: true,
            export: true,
            render: (row) => {
              return (
                <Grid
                  container
                  alignItems="center"
                  justifyContent="flex-start"
                  className="context-menu-hover-container"
                  wrap="nowrap"
                >
                  
                  <div
                    style={{
                      display: 'flex', // Uso de flexbox
                      alignItems: 'center', // Alineación vertical al centro
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: `#${row?.color?.replace('#', '') }`,
                        width: '20px',
                        height: '20px',
                        borderRadius: '4px',
                        marginRight: '10px'
                      }}
                    ></div>
                  </div>                 
                  <div style={{ width: 200 }}>
                    {
                      row?.title?.length > 22
                      ?
                      <Tooltip title={row?.title} placement={'bottom'} /* type={ props?.tooltipType || null} */ >
                        <Typography className='template-routes-cut-text' noWrap>{row?.title}</Typography>
                      </Tooltip>
                      :
                      <Typography className='template-routes-cut-text' noWrap>{row?.title}</Typography>
                    }
                  </div>
    
                  {
                    /* HasPermission(user, "", [26]) && */
                    <Grid item justifyContent="flex-end">
                      <MenuComponent
                        disabled={loadingRoutes}
                        options={[
                          messages['edit'],
                          //messages['delete'],
                          //messages['fsmRoute_label_add_clone_route']
                        ]}
                        icon={'more_vert'}
                        placement={'right-start'}
                        className="context-menu-hover"
                        onClick={(type, value) => {
                          if (type === messages['edit']) {
                            dispatch(openModalCreateEditRouteModalMain({open: true, id: value.id, isTemplate: false, isRoutesTracker: true }));

                          } /* else if (type === messages['delete']) {

                            const payload = {
                              open: true,
                              id: value.id,
                              type: "route",
                              title: `${messages['routes_deleteRouteTitle']} ${value.title}`,
                              content: messages['routes_deleteRouteContent']
                            }
                          }  else if (type === messages['fsmRoute_label_add_clone_route']) {
                            dispatch((openModalRoutesCloneRoute({ open: true, id: value.id, title: value?.title })));
                          } */
                        }}
                        value={row}
                      />
                    </Grid>
                  }
                </Grid>
              )
            },
            exportValue: (row) => {
              return row?.name;
            },
            functionString: 'return row?.name || ""'
          },
          {
            key: 'avatar',
            title: '',
            show: true,
            export: false,
            render: (row) => {
              return (
                <Grid
                  container
                  alignItems="center"
                  className="context-menu-container"
                  wrap="nowrap"
                >
                  <Avatar fileKey={row?.driver?.avatarFile?.fileKey}  name={row?.driver?.name} />
                </Grid>
              )
            }
          },
          {
            key: 'driver',
            title: messages['fsmRoute_routesTracker_driver'], //name
            show: true,
            export: true,
            render: (row) => {
              return (
                <div style={{ width: 200 }}>
                    {
                      row?.driver?.name > 22
                      ?
                      <Tooltip title={row?.title} placement={'bottom'} /* type={ props?.tooltipType || null} */ >
                        <Typography className='template-routes-cut-text' noWrap>{row?.driver?.name}</Typography>
                      </Tooltip>
                      :
                      <Typography className={`template-routes-cut-text ${ row?.driver?.name ? '': 'routes-tracker-unassigned'}`} noWrap>
                        {row?.driver?.name || messages['fsmRoute_routesTracker_stops_status_unassigned']}
                      </Typography>
                    }
                    {
                      row?.driver?.name 
                      && 
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Tooltip title={messages['fsmRoute_routesTracker_stops_status_vehicle']} placement={'bottom'}>
                          <Typography className={`template-routes-cut-text ${ row?.driver?.unit?.label ? '': 'routes-tracker-unassigned-unit'}`} noWrap>
                            {row?.driver?.unit?.label || messages['fsmRoute_routesTracker_stops_status_unassigned']}
                          </Typography>
                        </Tooltip>
                        {
                          row?.driver?.unit?.id
                          &&
                          <Tooltip
                            key={row?.driver?.unit?.label}
                            title={messages['fleetView_unitOverViewPanel']}>
                            <IconButton
                                style={{ color: 'black' }}
                                icon="gps_fixed"
                                onClick={() => {
                                    dispatch(
                                        openOverViewUnit({
                                            data: { unit: { id:row?.driver?.unit?.id, label: row?.driver?.unit?.label } },
                                            open: true,
                                        }))
                                }}
                            />
                          </Tooltip>
                        }
                    </div>
                  }
                </div>
              )
            },
            exportValue: (row) => {
              return row?.driver?.name;
            },
            functionString: 'return row?.driver?.name || ""'
          },
          {
            key: 'status',
            title: messages['fsmRoute_routesTracker_stops_status'], 
            show: true,
            export: true,
            render: (row) => {
              const valueStatus = ColorsToRouteStatus.find((item) => item.name == row?.status)
              return (
                <div style={{ width: 100 }}>    
                  <NewPill
                    item={{
                      color: valueStatus?.color,
                      id: '1',
                      label: messages[valueStatus?.messages]
                    }}
                    onClick={() => {}}
                    onClickIcon={function noRefCheck() {}}
                    style={{}}
                    variant="filled"
                  />
                </div>
              )
            },
            exportValue: (row) => {
              return row?.status;
            },
            functionString: 'return row?.status || ""'
          },
          {
            key: 'schedule',
            title: messages['fsmRoute_routesTracker_schedule_at'], //name
            show: true,
            export: true,
            render: (row) => {
              let date = getDate(row?.scheduledAt, timeZoneUser);
              return (
                <div style={{ width: 100 }}>
                {
                    row?.scheduledAt && date.isValid() &&
                    <Fragment>
                        <Timezone
                            //oneControl
                            onlyHour
                            date={row?.scheduledAt}
                            dateFormat={""}
                            timeFormat={"h:mm a"}
                            timezone={timeZoneUser}
                            className="routes-tracker-TimeZoneClassName"
                            fromNow={true}
                            lang={locale}
                        /> 
                        <div className='subtitle'>{date.locale(locale).format('MMM DD, YYYY')}</div>
                    </Fragment>
                }
                </div>
              )
            },
            exportValue: (row) => {
              return row?.name;
            },
            functionString: 'return row?.name || ""'
          },
          {
            key: 'stopsVisited',
            title: messages['fsmRoute_routesTracker_stops_visited'], //name
            show: true,
            export: true,
            render: (row) => {
              return (
                <div style={{ width: 100 }}>
                  <a  className="routes-stops-visited" 
                      noWrap
                      onClick={()=> {
                        dispatch(openModalRoutesTrackerStopsVisited({ open: true, routeId: row.id}))
                      }} >
                    {`${row?.stopsVisitedCount} / ${row?.pointsCount}`}
                  </a>
                </div>
              )
            },
            exportValue: (row) => {
              return row?.name;
            },
            functionString: 'return row?.name || ""'
          },
          {
            key: 'tracker',
            title: messages['fsmRoute_routesTracker_stops_detail'], //name
            show: true,
            export: true,
            style: { zIndex: 5},
            render: (row) => {
              let countRoutePoints = -1;
              return (
                <Grid
                  container
                  alignItems="center"
                  justifyContent="flex-start"
                  className="context-menu-hover-container"
                  wrap="nowrap"
                  style={{ position: 'relative' }}
                >
                  {
                    row.points &&
                    row.points.map((item, number) => {
                        if(item.typePoint == 'Waypoint'){
                          return (<></>)
                        }
                        countRoutePoints = countRoutePoints + 1;
                        let itemToShow = ColorsToRoutePointsOnRoutesTracker.find((element) => element.name == item.status)
                        
                        //if route are done, show all points as done
                        if(row?.status == 'Done' && item.status != 'DoneWithException'){ 
                          itemToShow = ColorsToRoutePointsOnRoutesTracker.find((element) => element.name == "Done")
                        }
                        return(
                          
                            <div 
                              key={countRoutePoints}  
                              className="route-tracker-modal-items-div"
                                onClick={() => {
                                    dispatch(openModalRoutesTrackerStopInformation({ open: true, routePointId: item.id }))
                                  }}
                                >
                                <div style={{ zIndex: 3, cursor: 'pointer' }}>
                                  <Tooltip placement="top" title={`${messages[itemToShow?.messages]} - ${item?.name}`}>
                                    <IconMarkerRoutesTrackerSmall  color={itemToShow?.color || '#d3d3d3'} number={countRoutePoints + 1} size={"small"}/>
                                  </Tooltip>
                                </div>

                                {/* draw all line in route */}
                                { (countRoutePoints == 0 ) && <div className={'line-route-size-pending-start'}/> }
                                { (countRoutePoints > 0 ) && <div className={'line-route-size-pending-middle'}/> }

                                
                                 {/* draw line progress */}
                                { (item?.status != "Pending" &&  countRoutePoints == 0) && <div className={'line-route-size-color-start'} /> }
                                { (item?.status != "Pending" && countRoutePoints > 0) && <div  className={'line-route-size-color-middle'} />}


                                { 
                                    (item?.status == "InRoute")
                                    && <AirportShuttleIcon className='line-route-icon-vehicle' />
                                }

                                { /* Draw vehicle icon in route */
                                    (row?.status != 'Done' && item?.status == "OnSite")
                                    && <TimeToLeaveIcon className='line-route-icon-onsite-vehicle' />
                                }
                            </div>
                        )
                    })
                  }
                </Grid>
              )
            },
            exportValue: (row) => {
              return row?.name;
            },
            functionString: 'return row?.name || ""'
          }
    
        ]);
      }, [locale, timeZoneUser]);

    //start date format
    const utcDateStart = moment.utc(dateStart);
    const dateStartDateFormat = utcDateStart.tz(timeZoneUser);
    let startDatePill = dateStartDateFormat.format(`${GetFormatForMoment(dateformat)} hh:mm A`);

    //end date format
    const utcDateEnd = moment.utc(dateEnd);
    const dateEndDateFormat = utcDateEnd.tz(timeZoneUser);
    let endDatePill = dateEndDateFormat.format(`${GetFormatForMoment(dateformat)} hh:mm A`);

    return(
      <Container maxWidth={false}>        
        <div id="containeGridNewRoutes">
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid item xs={6} sm={2}>
                      <Grid
                          container
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={1}
                      >

                            <Grid item>
                              <div style={{ marginLeft: 6 }}>

                                <IconButton
                                  variant={"secondary"}
                                  isDisabled={false}
                                  icon="filter_list"
                                  style={{ fontSize: 22, color: '#212121'}}
                                  tooltip={messages['filter']}
                                  onClick={(e) => {
                                    dispatch(openModalRoutesTrackerFilter({open: true}));
                                  }}
                                />
                              </div>
                            </Grid>

                          {
                            /* HasPermission(user, "ve", [25]) && */
                            <Grid item>
                              <div style={{ marginLeft: 6 }}>

                                <IconButton
                                  variant={"secondary"}
                                  isDisabled={false}
                                  icon="add_box"
                                  style={{ fontSize: 22, color: '#212121'}}
                                  tooltip={messages['add']}
                                  onClick={(e) => {
                                    dispatch(openModalRoutesTrackerAddRoutesTracker({open: true}));
                                  }}
                                />
                              </div>
                            </Grid>
                          }

                          {
                              (pagination?.selectedItems.length > 0) && 
                              <Grid item>
                                  <IconButton
                                      icon="delete"
                                      placement="bottom"
                                      variant="secondary"
                                      size="small"
                                      tooltip={messages['delete']}
                                      isDisabled={loadingRoutes}
                                      onClick={() => {
                                        let payload = {
                                          open: true,
                                          type: "route",
                                          content: messages['routes_deleteRouteContent']
                                        };
                                        if(pagination?.selectedItems.length == 1){
                                          payload = {
                                            ...payload,
                                            id: pagination?.selectedItems[0].id,
                                            rows: [{ id: pagination?.selectedItems[0].id, name: pagination?.selectedItems[0]?.title }],
                                            title: messages['routes_delete_routes_title']
                                          }
                                        }else if(pagination?.selectedItems.length > 1){
                                          payload = {
                                            ...payload,
                                            rows: pagination?.selectedItems.map((item) => ({ ...item, name: item.title })),
                                            type: 'route_multiple',
                                            title: messages['routes_delete_routes_title']
                                          }
                                        }
                                        dispatch(openModalDeleteRoutes(payload));
                                      }}
                                  />
                              </Grid>
                          }
                      </Grid>
                  </Grid>
                  <Grid>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}>
                            <Pill
                              key={'pillTime'}
                              textField={"label"}
                              item={timeFrameOptionSelected ? {...timeFrameOptionSelected, label: `${timeFrameOptionSelected.label} (${startDatePill} - ${endDatePill})` } : []}
                              outlined={false}
                              style={{ border: "2" }}
                              label="pill-label-text"
                              colorField="default"
                              colorSelection="005bf8"
                              onClick={()=>{
                                dispatch(openModalRoutesTrackerFilter({open: true}));
                              }}
                            />
                        </div>
                  </Grid>

                  <Grid item xs={12} sm={4} className="mb-10 text-right">
                    <SearchInput
                      placeholder={messages['search']}
                      {...pagination}
                      onSearchText={onSearchText}
                    />
                  </Grid>

              </Grid>


                  
          <Table
              ref={routesTableRef}
              keyColumn="id"
              loading={loadingRoutes}
              topheight={235}
              data={data?.items || []}
              exportOrientation='landscape'
              exportName='routes-table'
              
              {...pagination}

              total={data?.total || 0}
              onChangePage={(newPage) => {
                onChangePage(newPage, rowsPerPage, pagination.searchText);
              }}
              onChangeRowsPerPage={(newRowsPerPage) => {
                setRowsPerPage(newRowsPerPage);
                onChangePage(1, newRowsPerPage, pagination.searchText);
              }}
              rowsPerPage={rowsPerPage}
              valuesPerPage={[10, 25]}

              //hideDragable
              //disableItemSelection={!HasPermission(user, "", [26])}
          />
        </div>


      {/* { openModalFilter && <ModalRouteFilters />} */}
      <ModalRouteFilters />
      { openModalRouteStopInformation && <ModalRouteStopInformation />}
      { openModalRouteStopsVisited && <ModalRouteStopVisited />}
      { openAddRoutesTracker && <ModalAddRoutesTracker /> }

      </Container>
      
    )

}

export default RoutesTracker;

